import React, { useState } from "react";
import { useSelector } from "react-redux";

import { makeStyles, Typography, Grid, IconButton } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

import SolarIcon from "../../../../../assets/images/icons/solar.svg";
import EVIcon from "../../../../../assets/images/icons/ev-charge.svg";
import BatteryIcon from "../../../../../assets/images/icons/battery.svg";

import { getActivity } from "../ByType/ByTypeTable";
import { StatusBox } from "../../../../../components/boxes/StatusBox";

import { StyledTableRow, StyledTableCell } from "../../../../../components/base/Table";
import { nKilowattFormatter, currencyFormatter } from "../../../../../services";
import { COLORS } from "../../../../../theme/colors";
import { useComputePowerAssetsTotal } from "../useComputePowerAssetsTotal";

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: "bold",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    width: 30,
    height: 30,
    borderWidth: 1,
    borderStyle: "solid",
    marginRight: 14,
    backgroundColor: COLORS.white,
  },
  batteryBorderColor: {
    borderColor: COLORS.majorelleBlue,
  },
  evBorderColor: {
    borderColor: COLORS.cian,
  },
  solarBorderColor: {
    borderColor: COLORS.mikadoYellow,
  },
  hiddenRow: {
    display: "none",
  },
}));

const getPowerAssetIcon = (type) => {
  switch (type) {
    case "BATTERY":
      return <img src={BatteryIcon} width="14" alt="" />;
    case "EV":
      return <img src={EVIcon} width="18" alt="" />;
    case "SOLAR":
      return <img src={SolarIcon} width="20" alt="" />;
    default:
      return;
  }
};

export const ByBuildingTableBuildingRows = ({ building, onClick }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const [totalProduction, totalAccumulatedRevenue] = useComputePowerAssetsTotal(
    building.building_assets
  );

  return (
    <React.Fragment key={building.id}>
      <StyledTableRow key={building.id} style={{ backgroundColor: COLORS.white }}>
        <StyledTableCell
          rowSpan={open ? building.building_assets.length + 1 : 1}
          style={{
            borderRight: `1px solid ${COLORS.darks[0][25]}`,
            verticalAlign: "top",
          }}
        >
          <Grid container alignItems="center" wrap="nowrap">
            <Grid item>
              <IconButton size="small" onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRight />}
              </IconButton>
            </Grid>
            <Grid item>
              <Typography variant="body1">{building.address}</Typography>
            </Grid>
          </Grid>
        </StyledTableCell>
        <StyledTableCell>
          <Typography variant="h5" className={classes.bold}>
            {building.building_assets.length} Power Assets
          </Typography>
        </StyledTableCell>
        <StyledTableCell>
          <Typography variant="body1">{nKilowattFormatter(totalProduction)}</Typography>
        </StyledTableCell>
        <StyledTableCell>
          <Typography variant="body1">
            {currencyFormatter(totalAccumulatedRevenue, currencySymbol)}
          </Typography>
        </StyledTableCell>
        <StyledTableCell></StyledTableCell>
        <StyledTableCell></StyledTableCell>
      </StyledTableRow>
      {building.building_assets.map((entry) => (
        <StyledTableRow
          key={entry.id}
          style={{ backgroundColor: COLORS.white, cursor: "pointer" }}
          className={open ? undefined : classes.hiddenRow}
          onClick={() => onClick(entry.id)}
        >
          <StyledTableCell
            style={{
              padding: 13,
            }}
          >
            <Grid container alignItems="center">
              <div
                className={`${classes.icon} ${classes[entry.type.toLowerCase() + "BorderColor"]}`}
              >
                {getPowerAssetIcon(entry.type)}
              </div>
              <Typography variant="body1">{entry.type}</Typography>
            </Grid>
          </StyledTableCell>
          <StyledTableCell>
            <Typography variant="body1">{nKilowattFormatter(entry.production)}</Typography>
          </StyledTableCell>
          <StyledTableCell>
            <Typography variant="body1">
              {currencyFormatter(entry.acc_revenue, currencySymbol)}
            </Typography>
          </StyledTableCell>
          <StyledTableCell>
            <StatusBox status={entry.status} />
          </StyledTableCell>
          <StyledTableCell>
            <Typography variant="body1">{getActivity(entry.power_assets_activity)}</Typography>
          </StyledTableCell>
        </StyledTableRow>
      ))}
    </React.Fragment>
  );
};
